import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class LoyaltyStore {
    loading = false;
    userLevelInfo = null;
    levels = [];
    privileges = [];
    bonusGetInfo = null;
    bonusHistory = [];

    getLevels = () => {
        this.loading = true;

        Api.fetch('bonus/my')
            .then(response => {
                if (response.success) {
                    this.userLevelInfo = response.result;
                    this.levels = response.result?.levels;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    getPrivileges = () => {
        this.loading = true;

        Api.fetch('bonus/privilege')
            .then(response => {
                if (response.success) {
                    this.privileges = response.result?.privileges_all;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    getBonusGetInfo = () => {
        this.loading = true;

        Api.fetch('bonus/how-get-points')
            .then(response => {
                if (response.success) {
                    this.bonusGetInfo = response.result;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    getBonusHistory = () => {
        this.loading = true;

        Api.fetch('bonus/history')
            .then(response => {
                if (response.success) {
                    this.bonusHistory = response.result;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };
}

decorate(LoyaltyStore, {
    loading: observable,
    userLevelInfo: observable,
    levels: observable,
    privileges: observable,
    bonusGetInfo: observable,
    bonusHistory: observable,

    getLevels: action,
    getBonusHistory: action,
    getPrivileges: action,
    getBonusGetInfo: action,
});
